export default __webpack_public_path__ + "6715731267413b1cf139f1c7143d8a13.ogg";